import React from 'react'
import { Interviews } from './interviews'
import { Quotes } from './quotes'
import { AddMeetingCard } from './addMeetingCard'
// import { Facilitators } from './facilitators'
// import { Method } from './method'

export function OverviewSidebar() {
  return (
    <div className="flex flex-col gap-[32px]">
      <AddMeetingCard />
      <Interviews />
      <Quotes />
    </div>
  )
}
